import axios from 'axios';
import ServicePath from '../../../services/webservice';
import { AesEncrypt, AesDecrypt } from '../../../services/crypto';

const API_URL = ServicePath + 'api/ai-insights';

const handleResponse = (response) => {
    if (response.data && response.data.response === 'S') {
        const decryptedData = AesDecrypt(response.data.data);
        return { success: true, data: decryptedData };
    }
    return { success: false, message: response.data.message || 'Unknown error' };
};

const handleError = (error) => {
    console.error("API Error:", error);
    return { success: false, message: error.message || 'Network Error' };
};

export const fetchStats = async (filters) => {
    try {
        const Encparams = AesEncrypt(filters);
        const response = await axios.post(`${API_URL}/stats`, { Encparams });
        return handleResponse(response);
    } catch (error) {
        return handleError(error);
    }
};

export const fetchAuditList = async (params) => {
    try {
        const Encparams = AesEncrypt(params);
        const response = await axios.post(`${API_URL}/list`, { Encparams });
        // Response data structure in list: list, totalCount, page, rowsPerPage
        return handleResponse(response);
    } catch (error) {
        return handleError(error);
    }
};

export const fetchAuditDetail = async (id) => {
    try {
        const Encparams = AesEncrypt({ id });
        const response = await axios.post(`${API_URL}/detail`, { Encparams });
        return handleResponse(response);
    } catch (error) {
        return handleError(error);
    }
};

export const fetchCostStats = async (filters) => {
    try {
        const Encparams = AesEncrypt(filters);
        const response = await axios.post(`${API_URL}/cost-stats`, { Encparams });
        return handleResponse(response);
    } catch (error) {
        return handleError(error);
    }
};
